import { DefaultTheme } from 'styled-components/macro'

export const HEADER_HEIGHT = 80
export const FOOTER_HEIGHT = 80

export const theme = {
  colors: {
    main: '#003c7d',
    mainPressed: '#003064',
    secondary: '#f1f5f8',
    secondaryPressed: '#e4ebf2',
    gray: '#f2f2f2',
    veryLightPink: '#dfdfdf',
    paleGrey: '#f1f5f8',
    buttonBorderSecondary: '#dfdfdf',
    inputBorder: '#dfdfdf',
    brownGray: '#a1a1a1',
    veryLightBlue: '#e4ebf2',
    pumpkinOrange: '#ff7500',
    brownyOrange: '#cc5e00',
    white: '#ffffff',
    powderBlue: '#c9d9e5',
    dustyBlue: '#5c8ab3',
    marineBlue: '#003064',
    grayishBrown: '#505050',
    whiteGray: '#f4f4f4',
    darkMint: '#35d57b',
    navy: '#001832',
    almostWhite: '#f9f9f9',
    watermelon: '#ff3c65',
    plum: '#661828'
  },
  fontSizes: {
    extraSmall: '12px',
    small: '14px',
    medium: '16px',
    large: '24px',
    extraLarge: '32px'
  },
  animation: {
    duration: '0.3s'
  }
}

export const gridTheme = {
  breakpoints: {
    xl: 1920,
    lg: 1366,
    md: 1024,
    sm: 768,
    xs: 767
  },
  row: {
    padding: 20
  },
  col: {
    padding: 20
  },
  container: {
    padding: 0
  }
}

export type Type = 'primary' | 'normal' | 'secondary' | 'ghost' | 'dusty' | 'danger'

export const colorByType = (t: DefaultTheme, type?: Type) => {
  switch (type) {
    case 'primary':
      return t.colors.main
    case 'secondary':
      return t.colors.brownGray
    case 'ghost':
      return t.colors.white
    case 'dusty':
      return t.colors.dustyBlue
    case 'danger':
      return t.colors.watermelon
    default:
      return t.colors.grayishBrown
  }
}
